
<div class="sms-tests">
  <section class="header">
    <div class="copy">
      <p class="eyebrow">SMS playground</p>
      <h1>Test and stage outbound texts</h1>
      <p class="lede">
        Shape the payload, preview the copy, and send against the sandbox gateway without touching production comms.
      </p>
      <div class="chips">
        <span class="pill muted">Mode: {{ smsForm?.get('type')?.value | uppercase }}</span>
        <span class="pill" *ngIf="selectedTemplate">Template: {{ selectedTemplate.name }}</span>
        <button mat-stroked-button color="primary" (click)="useSandboxValues()" type="button">
          Reset to sandbox values
        </button>
      </div>
    </div>
    <div class="side-card">
      <div class="side-row">
        <div>
          <p class="label">Intent</p>
          <p class="value">Proof and QA for SMS flows</p>
        </div>
        <mat-icon>check_circle</mat-icon>
      </div>
      <div class="side-row">
        <div>
          <p class="label">Templates under test</p>
          <p class="hint">Invoice, review request, repair ready</p>
        </div>
        <mat-icon>sms</mat-icon>
      </div>
      <div class="side-row">
        <div>
          <p class="label">Tip</p>
          <p class="hint">Use +61 format and keep type as "test" to avoid production spend.</p>
        </div>
        <mat-icon>lightbulb</mat-icon>
      </div>
    </div>
  </section>

  <section class="grid">
    <article class="card send-card">
      <div class="section-heading">
        <div>
          <p class="eyebrow">Sandbox send</p>
          <h3>Compose the payload</h3>
          <p class="hint">Wire the basics: destination, sender label, template, and variables.</p>
        </div>
        <div class="actions">
          <button mat-stroked-button color="accent" type="button" (click)="useSandboxValues()">Use defaults</button>
          <button mat-flat-button color="primary" type="submit" (click)="sendTestSMS()" [disabled]="status === 'sending'">
            {{ status === 'sending' ? 'Sending...' : 'Send test SMS' }}
          </button>
        </div>
      </div>

      <form [formGroup]="smsForm" class="field-grid" (ngSubmit)="sendTestSMS()">
        <mat-form-field appearance="outline">
          <mat-label>To (E.164)</mat-label>
          <input matInput formControlName="to" placeholder="+614..." />
          <mat-error *ngIf="smsForm.get('to')?.invalid && smsForm.get('to')?.touched">Destination number is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>From label</mat-label>
          <input matInput formControlName="from" placeholder="Repair Lab" />
          <mat-error *ngIf="smsForm.get('from')?.invalid && smsForm.get('from')?.touched">Sender label is required</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Mode</mat-label>
          <mat-select formControlName="type">
            <mat-option value="test">Test</mat-option>
            <mat-option value="production">Production</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Template</mat-label>
          <mat-select formControlName="template" (selectionChange)="onTemplateChange($event.value)">
            <mat-option *ngFor="let template of templates" [value]="template.id">
              {{ template.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>

      <div class="variables" *ngIf="variableForm">
        <div class="variable-header">
          <div>
            <p class="eyebrow">Template variables</p>
            <p class="hint">Quickly swap placeholders to test message personalization.</p>
          </div>
          <div class="pill muted" *ngIf="selectedTemplate">{{ selectedTemplate.description }}</div>
        </div>
        <div class="variable-grid" [formGroup]="variableForm">
          <mat-form-field appearance="outline" *ngFor="let key of variableKeys">
            <mat-label>{{ key }}</mat-label>
            <input matInput [formControlName]="key" />
            <mat-error *ngIf="variableForm.get(key)?.invalid && variableForm.get(key)?.touched">Value required</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="status-row">
        <div class="pill success" *ngIf="status === 'success'">Sent - check the gateway response below.</div>
        <div class="pill error" *ngIf="status === 'error'">{{ errorMessage }}</div>
        <div class="pill muted" *ngIf="status === 'sending'">Sending...</div>
        <div class="pill muted" *ngIf="status === 'idle'">No SMS sent yet.</div>
        <button mat-flat-button color="primary" type="button" (click)="sendTestSMS()" [disabled]="status === 'sending'">
          {{ status === 'sending' ? 'Sending...' : 'Send test SMS' }}
        </button>
      </div>
    </article>

    <article class="card preview-card">
      <div class="section-heading">
        <div>
          <p class="eyebrow">Preview</p>
          <h3>Rendered message & payload</h3>
          <p class="hint">Check the copy and payload that will be posted to the SMS service.</p>
        </div>
      </div>

      <div class="preview-bubble">
        <p class="label">Message preview</p>
        <div class="bubble">{{ previewCopy }}</div>
      </div>

      <div class="payload">
        <p class="label">Request payload</p>
        <pre>{{ payloadPreview | json }}</pre>
      </div>

      <div class="payload" *ngIf="response">
        <p class="label">Gateway response</p>
        <pre>{{ response | json }}</pre>
      </div>
    </article>
  </section>
</div>
